import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from 'seagull';
import ConfirmExternallySignModal from '~/components/ConfirmExternallySignModal/ConfirmExternallySignModal';
import { ErrorResponse } from '~/infra/ErrorResponse';
import { bulkExternallySignErrorText } from './DraftsDashboard.utils';
import { ImportDraftsModal } from './ImportDraftsModal';
const failedSelection = (failedDraftIds)=>failedDraftIds.reduce((acc, draftId)=>_object_spread_props(_object_spread({}, acc), {
            [draftId]: true
        }), {});
export const bulkSendAction = (param)=>{
    let { selectedDrafts, draftsTexts, DraftsDashboardTID, drafts, errorTexts, createRelationshipFromDraft, handlePromise, setSelected } = param;
    return {
        bulkItemIds: selectedDrafts,
        confirmation: {
            title: draftsTexts.sendProposalsInBulkTitle(),
            primaryButtonLabel: draftsTexts.sendProposalsButton(),
            content: /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            draftsTexts.sendProposalsConfirmationPrefix(),
                            ' ',
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: DraftsDashboardTID.RemoveModalTemplateName(),
                                as: "span",
                                weight: "bold",
                                children: selectedDrafts.length
                            }),
                            ' ',
                            draftsTexts.sendProposalsConfirmationSuffix()
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: draftsTexts.considerSending()
                    })
                ]
            })
        },
        progressTitle: draftsTexts.sendProposalsInBulkTitle(),
        actionName: draftsTexts.sendProposalsActionName(),
        itemName: draftsTexts.sendProposalsItemName(),
        errorExtra: draftsTexts.sendProposalsErrorExtra(),
        canProcessItem: ()=>true,
        processSingleItem: (draftId)=>handlePromise(createRelationshipFromDraft(draftId).catch((err)=>{
                var _draft_contactDetails;
                const draft = drafts.find((draft)=>draft.id === draftId);
                const email = draft === null || draft === void 0 ? void 0 : (_draft_contactDetails = draft.contactDetails) === null || _draft_contactDetails === void 0 ? void 0 : _draft_contactDetails.email;
                const errorText = new ErrorResponse(err).createRelationshipErrorText(errorTexts);
                const draftInfo = "".concat(draft ? draft.title : draftsTexts.draftFallback()).concat(email ? " (".concat(email, ")") : '');
                throw "".concat(draftInfo, " - ").concat(errorText.text);
            })),
        onDone: (failedDraftIds)=>setSelected(failedSelection(failedDraftIds))
    };
};
export const bulkExternallySignAction = (param)=>{
    let { selectedDrafts, draftsTexts, api, handlePromise, draftsMap, defaultAgreementTitle, errorTexts, editTableTexts, setSelected } = param;
    return {
        bulkItemIds: selectedDrafts,
        confirmation: {
            renderModal: (p)=>/*#__PURE__*/ _jsx(ConfirmExternallySignModal, _object_spread_props(_object_spread({}, p), {
                    bulkData: {
                        numClients: selectedDrafts.length
                    }
                }))
        },
        progressTitle: draftsTexts.approveOnBehalfProgressTitle(),
        actionName: draftsTexts.approveOnBehalfActionName(),
        progressAction: draftsTexts.approveOnBehalfAction(),
        itemName: draftsTexts.approveOnBehalfItemName(),
        errorExtra: draftsTexts.approveOnBehalfErrorExtra(),
        canProcessItem: ()=>true,
        processSingleItem: (draftId)=>handlePromise(api.relationship.createFromDraft(draftId, {
                externallySign: true
            })),
        getErrorText: (draftId, error)=>bulkExternallySignErrorText(draftsMap.get(draftId), error, defaultAgreementTitle, errorTexts, editTableTexts),
        onDone: (failedDraftIds)=>setSelected(failedSelection(failedDraftIds))
    };
};
export const bulkDiscardAction = (param)=>{
    let { selectedDrafts, draftsTexts, DraftsDashboardTID, api, handlePromise, setSelected } = param;
    return {
        bulkItemIds: selectedDrafts,
        progressAction: draftsTexts.discardAction(),
        confirmation: {
            title: draftsTexts.discardDraftsTitle(),
            primaryButtonLabel: draftsTexts.discardButton(),
            content: /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            draftsTexts.areYouSureDiscardDraftsPrefix(),
                            ' ',
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: DraftsDashboardTID.RemoveModalTemplateName(),
                                as: "span",
                                weight: "bold",
                                children: selectedDrafts.length
                            }),
                            ' ',
                            draftsTexts.areYouSureDiscardDraftsSuffix({
                                count: selectedDrafts.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: draftsTexts.thisActionCannotBeUndone()
                    })
                ]
            })
        },
        progressTitle: draftsTexts.discardDraftsTitle(),
        actionName: draftsTexts.discardActionName(),
        itemName: draftsTexts.discardItemName(),
        canProcessItem: ()=>true,
        processSingleItem: (draftId)=>handlePromise(api.draft.deleteById(draftId)),
        onDone: (failedDraftIds)=>setSelected(failedSelection(failedDraftIds))
    };
};
export const importDraftsModal = (param)=>{
    let { importModalTexts, closeButtonTestId, noteClassName } = param;
    return {
        biName: 'drafts_dashboard_import_modal_confirm',
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(ImportDraftsModal, {
                texts: importModalTexts,
                closeButtonTestId: closeButtonTestId,
                noteClassName: noteClassName,
                dismissModal: dismissModal
            });
        }
    };
};
